import { gateway } from "../../../../gateway";

export const setInvoiceAsPaid = async (
    invoiceUid: string,
    companyId: number,
    payload: { method: "bank_transfer" | "cash"; transactionId?: string | null }
) => {
    try {
        const response = await gateway.patch(`/invoices/${invoiceUid}/mark-as-paid`, payload, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                "x-company-id": String(companyId)
            }
        });
        return response.data || response.data.data;
    } catch (error) {
        throw error;
    }
}